export const PAYMENT_OPTIONS = {
    CASH: {
        value: 'CASH',
        title: 'На месте',
    },
    ONLINE: {
        value: 'ONLINE',
        title: 'Картой онлайн',
    },
    CERT: {
        value: 'CERT',
        title: 'Подарочный сертификат',
    }
}
